/**
 * TanStack Query hooks for `drag-to-reorder-dashboard-layout`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dragToReorderDashboardLayoutQueryKeys,
	type CreateDragToReorderDashboardLayoutBody,
	type ListDragToReorderDashboardLayoutResponse,
	type DragToReorderDashboardLayoutRow,
} from "./api";

export function useDragToReorderDashboardLayoutList(): UseQueryResult<ListDragToReorderDashboardLayoutResponse, Error> {
	return useQuery({
		queryKey: dragToReorderDashboardLayoutQueryKeys.list(),
		queryFn: list,
	});
}

export function useDragToReorderDashboardLayoutCreate(): UseMutationResult<DragToReorderDashboardLayoutRow, Error, CreateDragToReorderDashboardLayoutBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dragToReorderDashboardLayoutQueryKeys.all });
		},
	});
}

export function useDragToReorderDashboardLayoutDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dragToReorderDashboardLayoutQueryKeys.all });
		},
	});
}
